import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../Assets/Images/remesalogo.png';
import slogan from '../Assets/Images/sloganremesa.png';
import europaIcon from '../Assets/Images/europa.png';
import americaIcon from '../Assets/Images/america.png';

function NavBar({ logged }) {
  const [regionOpen, setRegionOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const regionRef = useRef();
  const location = useLocation();

  // 🔹 Detecta si estamos en HomeUSA y ajusta región predeterminada
  const [selectedRegion, setSelectedRegion] = useState(() =>
    window.location.pathname.toLowerCase().includes("homeusa") ? "america" : "europa"
  );

  const toggleRegion = () => setRegionOpen(!regionOpen);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
    setRegionOpen(false);
    window.location.href = region === "europa" ? "/" : "/HomeUSA";
  };

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (regionRef.current && !regionRef.current.contains(event.target)) {
        setRegionOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // 🔹 Actualiza el estado si cambia la ruta (por si el usuario navega manualmente)
  useEffect(() => {
    if (location.pathname.toLowerCase().includes("homeusa")) {
      setSelectedRegion("america");
    } else {
      setSelectedRegion("europa");
    }
  }, [location]);

  return (
    <motion.header
      className="navbar"
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="navbar__wrapper">
        {/* IZQUIERDA: LOGO + SLOGAN */}
        <Link to="/" className="navbar__brand">
          <img src={logo} alt="Remesa España" className="navbar__logo" />
          <img src={slogan} alt="Slogan Remesa" className="navbar__slogan" />
        </Link>

        {/* CENTRO (solo desktop) */}
        <nav className="navbar__center">
          <NavLink to="/" end className="navbar__apple-button">
            Personal
          </NavLink>
          <NavLink to="/empresas" className="navbar__apple-button">
            Empresa
          </NavLink>
        </nav>

        {/* HAMBURGUESA */}
        <button
          className={`navbar__toggle ${menuOpen ? 'is-active' : ''}`}
          onClick={toggleMenu}
        >
          <span></span><span></span><span></span>
        </button>

        {/* MENÚ DERECHO + CENTRO OCULTO EN MOBILE */}
        <div className={`navbar__menu ${menuOpen ? 'open' : ''}`}>
          {/* Personal / Empresa (solo mobile) */}
          <nav className="navbar__center navbar__center--mobile">
            <NavLink to="/" end className="navbar__apple-button">
              Personal
            </NavLink>
            <NavLink to="/empresas" className="navbar__apple-button">
              Empresa
            </NavLink>
          </nav>

          {/* DERECHA */}
          <div className="navbar__right">
            <div className="navbar__region" ref={regionRef}>
              <button className="dropdown-button" onClick={toggleRegion}>
                <img
                  src={selectedRegion === "europa" ? europaIcon : americaIcon}
                  alt={selectedRegion}
                  className="icon"
                />
                {selectedRegion === "europa"
                  ? "Envío a Europa"
                  : "Envío a América"}
                <span className="arrow">▼</span>
              </button>

              {regionOpen && (
                <div className="dropdown-menu">
                  <button
                    className={selectedRegion === "europa" ? "selected" : ""}
                    onClick={() => handleRegionSelect("europa")}
                  >
                    <img src={europaIcon} alt="Europa" className="icon" /> Envío a Europa
                  </button>
                  <button
                    className={selectedRegion === "america" ? "selected" : ""}
                    onClick={() => handleRegionSelect("america")}
                  >
                    <img src={americaIcon} alt="América" className="icon" /> Envío a América
                  </button>
                </div>
              )}
            </div>

            <NavLink
              to={logged ? "/Changes" : "/Login"}
              className="navbar__button"
            >
              Acceder
            </NavLink>

            <NavLink
              to="/Register"
              className="navbar__button navbar__button--primary"
            >
              Registro
            </NavLink>
          </div>
        </div>
      </div>
    </motion.header>
  );
}

export { NavBar };
